<!-- Configurable View Container -->
<div class="tw-flex tw-h-full tw-flex-col tw-overflow-hidden">
    <!-- Header Section with View Toggle and Actions -->
    <div
        class="tw-grid tw-auto-rows-auto tw-grid-cols-12 tw-gap-6 xl:tw-grid-rows-1 tw-flex-shrink-0">
        <!-- Filter Section -->
        @if (filterConfig()) {
            <div class="tw-order-1 tw-col-span-12">
                <app-paginated-table-filter
                    [showClosedLabel]="
                        filterConfig()!.showClosedToggle
                            ? 'GENERAL.SHOW-CLOSED'
                            : ''
                    "
                    [enableAdvancedFilters]="
                        filterConfig()!.enableAdvancedFilters !== false
                    "
                    [totalItems]="totalItems()"
                    [userRole]="userRole()"
                    [shouldShowLocationFilter]="shouldShowLocationFilter()"
                    [shouldShowColumnFilter]="shouldShowColumnFilter()"
                    [filteredLocationsCount]="filteredLocationsCount()"
                    [filteredColumnsCount]="filteredColumnsCount()"
                    [isLocationFilterActive]="isLocationFilterActive()"
                    [headerActions]="headerActions()"
                    [displayClosedToggle]="!isCustomView()"
                    [currentSelection]="selectedItems()"
                    (locationFilterClicked)="onLocationFilterClick()"
                    (columnFilterClicked)="onColumnFilterClick()"
                    (headerActionClicked)="onHeaderActionClick($event)">
                </app-paginated-table-filter>
            </div>
        }
    </div>

    <!-- Table Section -->
    <div class="tw-flex tw-flex-1 tw-flex-col tw-overflow-scroll tw-min-h-0">
        <!-- Custom views (including ECMR) -->
        @if (isCustomView()) {
            <ng-content select="[customView]"></ng-content>
        } @else {
            <div
                class="tw-flex tw-flex-1 tw-flex-col tw-min-h-0 tw-overflow-hidden">
                <!-- Generic Table Component - Hidden when share permissions dialog is open -->
                @if (!isSharePermissionsDialogOpen()) {
                    <app-generic-table
                        class="tw-flex-1 tw-min-h-0"
                        [data]="data()"
                        [columns]="tableColumns()"
                        [config]="
                            currentConfig()?.tableConfig || {
                                columns: [],
                                features: {},
                            }
                        "
                        [columnFilterKeys]="filterConfig()?.filterKeys ?? []"
                        [loading]="loading()"
                        [error]="error()"
                        [sortable]="
                            currentConfig()?.tableConfig?.features?.sortable ||
                            false
                        "
                        [filterable]="
                            currentConfig()?.tableConfig?.features
                                ?.filterable || false
                        "
                        [paginated]="
                            currentConfig()?.tableConfig?.features?.paginated ||
                            false
                        "
                        [tableClass]="
                            currentConfig()?.tableConfig?.cssClasses?.table ||
                            ''
                        "
                        [emptyStateMessage]="'GENERAL.NO-DATA'"
                        [showFilter]="true"
                        [showPagination]="shouldShowPagination()"
                        [locationScope]="userRole()"
                        (sortChange)="onSortChange($event)"
                        (pageChange)="onPageChange($event)"
                        (selectionChange)="onSelectionChange($event)"
                        (rowExpand)="onRowExpand($event)"
                        (refresh)="onRefresh()">
                    </app-generic-table>
                } @else if (isSharePermissionsDialogOpen()) {
                    <!-- Placeholder when share permissions dialog is open -->
                    <div
                        class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-64 tw-text-center tw-bg-gray-50 tw-rounded-lg">
                        <div class="tw-text-gray-400 tw-text-sm">
                            {{ 'GENERAL.TABLE_TEMPORARILY_HIDDEN' | translate }}
                        </div>
                    </div>
                }
            </div>
        }
    </div>
</div>
